import React from 'react';
import PlainButton from './common/PlainButton';
import {keyboardShortcuts} from '../utils/constants';

class KeyboardShortcutsPopup extends React.Component {

    handleClose = (event) => {
        // To close the current view
        this.props.onClose();
    }
    getLoc = (str) => {
        let Dyn = this.props.Dyn;
        return Dyn.loc( str );
    }

    onEscClick = event => {
        if(event.keyCode === 27) {
          this.handleClose(event)
        }
      }

    componentDidMount = () => {
        document.addEventListener("keydown", this.onEscClick, false);
    }

    componentWillUnmount = () => {
        document.removeEventListener("keydown", this.onEscClick, false);
    }

    replaceWithIcon = (str, key, iconClass) => {
        if(str.indexOf(key) === 0) {
            return <span><i className={"tde-i tde-s2 " + iconClass}></i>{str.substr(key.length)}</span>;
        } else {
            return <span>{str}</span>;
        }
    }

    render = () => {
        return (
            <div className="tde-keyboardShortcut-popup-wrapper tde-font-source-sans-pro" onClick={this.handleClose}>
                <div className="tde-keyboardShortcut-popup tde-bg-color tde-d-flex" onClick={e => e.stopPropagation()}>
                    <div className="tde-d-flex tde-justify-space-between tde-divider-bottom">
                        <h4
                            className="tde-card-title-text-color tde-my-4 tde-ml-5 tde-h3 tde-font-weight-semibold"
                            role="heading"
                            aria-level="1">{this.getLoc('Keyboard Shortcuts')}</h4>
                        <PlainButton ref="closeButton" title="Close" aria-label="" onClick={this.handleClose} className="tde-m-4 tde-pt-2 tde-close-attr-settings">
                            <i className="tde-i tde-i-remove"></i>
                        </PlainButton>
                    </div>
                    <div className="tde-keyboardShortcut-popup-body tde-flex-1" tabIndex="0" ref={ele => ele && ele.focus()}>
                        {keyboardShortcuts.map(( obj,i) =>
                            <React.Fragment key={i}>
                                <div className={"tde-d-flex tde-flex-items-center tde-divider-bottom tde-card-content-bg-color" + (i > 0? ' tde-divider-top':'')}>
                                    <h5 className="tde-text-uppercase tde-text-color tde-flex-2 tde-h6 tde-font-weight-bold tde-my-3 tde-pl-5">{this.getLoc(obj.component)}</h5>
                                    <p className="tde-text-color tde-flex-1 tde-h6 tde-font-weight-regular">Mac</p>
                                    <p className="tde-text-color tde-flex-1 tde-h6 tde-font-weight-regular">Windows</p>
                                </div>
                                {obj.shortcuts.map((shortcut, index) =>
                                    <div key={index} className={"tde-d-flex tde-ml-5" + (index < obj.shortcuts.length-1? ' tde-divider-bottom':'')}>
                                        <p className="tde-flex-2 tde-text-color tde-h6 tde-font-weight-regular tde-mx-0 tde-my-3">{this.getLoc(shortcut.desc)}</p>
                                        <p className="tde-text-color tde-flex-1 tde-h6 tde-font-weight-regular tde-mx-0 tde-my-3">{this.replaceWithIcon(shortcut.mac, 'command', 'tde-i-command-key')}</p>
                                        <p className="tde-text-color tde-flex-1 tde-h6 tde-font-weight-regular tde-mx-0 tde-my-3">{shortcut.windows}</p>
                                    </div>
                                )}
                            </React.Fragment>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default KeyboardShortcutsPopup
